import { render } from "./StorageTreePage.vue?vue&type=template&id=6cdbf45f"
import script from "./StorageTreePage.vue?vue&type=script&lang=js"
export * from "./StorageTreePage.vue?vue&type=script&lang=js"

import exportComponent from "../../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__